import { environmentBase } from '@lr/core';

/**
 * Test config for client portal when served at root (e.g. Azure Static Web App).
 * Same as environment.test but redirectUri is /callback so Auth0 redirects to root path.
 */
const portalOverrides = {
  auth: {
    ...environmentBase.auth,
    portalKey: 'client',
    redirectUri: window.location.origin + '/callback',
    clientId: 'GjTm33AHojc5szUkG6puQrncquNliivN'
  }
};

export const environment = {
  ...environmentBase,
  ...portalOverrides,
  enrollmentBaseUrl: 'https://enrollment.test.legalresources.com'
};
